import React, { useState, useEffect } from 'react';
import { personalInfo } from '../data/data';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const [displayedText, setDisplayedText] = useState('');
  const fullText = personalInfo.tagline;

  useEffect(() => {
    let index = 0;
    const typingInterval = setInterval(() => {
      if (index <= fullText.length) {
        setDisplayedText(fullText.slice(0, index));
        index++;
      } else {
        clearInterval(typingInterval);
      }
    }, 60);

    return () => clearInterval(typingInterval);
  }, [fullText]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center text-center px-6"
    >
      <div className="z-10">

        {/* NAME */}
        <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
          <span className="text-white">
            {personalInfo.name.split(' ')[0]}{' '}
          </span>

          {/* ✅ toned-down gradient instead of cyan glow */}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-teal-400">
            {personalInfo.name.split(' ')[1]}
          </span>
        </h1>

        {/* TAGLINE */}
        <h2 className="mt-6 text-xl md:text-2xl text-gray-300 min-h-[30px]">
          {displayedText}
        </h2>

        {/* SUBTEXT */}
        <p className="mt-4 text-gray-500 max-w-xl mx-auto">
          {personalInfo.subtitle}
        </p>

        {/* BUTTONS */}
        <div className="mt-8 flex justify-center gap-4">
          <button
            onClick={() => scrollToSection('projects')}
            className="px-6 py-3 border border-cyan-300 text-cyan-300 rounded-xl hover:bg-cyan-300 hover:text-black transition-all duration-300"
          >
            View Projects
          </button>

          <button
            onClick={() => scrollToSection('contact')}
            className="px-6 py-3 border border-gray-600 text-gray-300 rounded-xl hover:border-cyan-300 hover:text-cyan-300 transition-all duration-300"
          >
            Contact Me
          </button>
        </div>

        {/* SCROLL ICON */}
        <div className="mt-12 flex justify-center animate-bounce">
          <ChevronDown
            size={32}
            className="text-cyan-300 cursor-pointer"
            onClick={() => scrollToSection('about')}
          />
        </div>

      </div>
    </section>
  );
};

export default HeroSection;